import { call, put, takeLatest, all } from 'redux-saga/effects';
import { appsService } from '../../services/appsService';
import * as ActionTypes from '../actions/appActions';
import { push } from 'connected-react-router';
import { APPS_PATH } from '../../utils/constants';

// worker Saga: will be fired on APPS_FETCH_REQUESTED actions
function* fetchApps() {
  try {
    const apps = yield call(appsService.fetchAll);
    yield put({ type: ActionTypes.APPS_FETCH_SUCCEEDED, apps: apps });
  } catch (e) {
    yield put({ type: ActionTypes.APPS_FETCH_FAILED, error: e });
  }
}

function* createApp(action) {
  try {
    yield call(appsService.create, action.payload.app);
    const apps = yield call(appsService.fetchAll);
    yield put({ type: ActionTypes.APPS_FETCH_SUCCEEDED, apps: apps });
    yield put({ type: ActionTypes.APP_ADD_SUCCEEDED });
    yield put(push(APPS_PATH));
  } catch (e) {
    yield put({ type: ActionTypes.APP_ADD_FAILED, error: e });
  }
}

function* appsRootSaga() {
  yield all([
    yield takeLatest(ActionTypes.APPS_FETCH_REQUESTED, fetchApps),
    yield takeLatest(ActionTypes.APP_ADD_REQUESTED, createApp)
  ]);
}

export default appsRootSaga;



// WEBPACK FOOTER //
// ./src/redux/sagas/AppsSaga.js